import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { Button } from 'components/UI';
import { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';
import Modal from './Modal';
import styles from './RefreshModal.module.css';

export interface RefreshModalProps {
    refreshButtonLabel?: string;
    onRefresh?: () => void;
    onClose?: () => void;
    className?: string;
}

export const RefreshModal: FunctionComponent<RefreshModalProps> = props => {
    const isMobile = useMediaQuery({ query: '(max-width:600px)' });

    const header = (
        <div className={clsx(styles.header, styles.horizontalPadding)}>
            <FontAwesomeIcon
                icon={faTimes}
                fontSize={24}
                className={styles.closeIcon}
                onClick={props.onClose}
            />
        </div>
    );

    const body = (
        <div className={clsx(styles.body, styles.horizontalPadding)}>
            <span className={styles.title}>Recent Updates</span>
            <span className={styles.text}>
                Another user recently updated this booking. Click refresh to see the latest details.
            </span>
        </div>
    );

    const footer = (
        <div
            className={clsx({ [styles.footer]: !isMobile, [styles.mobileFooter]: isMobile }, styles.horizontalPadding)}
        >
            <Button
                label={props.refreshButtonLabel ?? 'Refresh'}
                color="black"
                className={clsx({ [styles.refreshButton]: !isMobile, [styles.mobileRefreshButton]: isMobile })}
                onClick={props.onRefresh}
            />
        </div>
    );

    return (
        <Modal
            onClose={props.onClose}
            isMobile={isMobile}
            className={props.className}
        >
            <div
                className={clsx({
                    [styles.content]: !isMobile,
                    [styles.mobileContent]: isMobile
                })}
            >
                {header}
                {body}
                {footer}
            </div>
        </Modal>
    );
};

export default RefreshModal;
